module.exports = __webpack_public_path__ + "371e174fa734db86d7c6a5b09330e2d1.MP3";